import { HsaFsaInlineLogo } from '@jouzen/ecom-components/icons/HsaFsaInlineLogo';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import type { ComponentProps, ReactNode } from 'react';

import RichText from '@/app/components/RichText';
import { useHsaFsa } from '@/app/hooks/useHsaFsa';

const FSA_HSA_FAQ_PAGE =
  'https://support.ouraring.com/hc/en-us/articles/19777137314579-Purchase-with-FSA-or-HSA-Funds';

interface HsaFsaInlineLinkProps {
  readonly className?: string;
  readonly typographyProps?: Partial<ComponentProps<typeof Typography>>;
}

const HsaFsaInlineLink = ({
  className,
  typographyProps,
}: HsaFsaInlineLinkProps) => {
  const hsaFsa = useHsaFsa();

  const tValue = {
    logo: () => <HsaFsaInlineLogo width={64} className="inline" />,
    Ulink: (chunks: ReactNode) => {
      return (
        <a
          className="underline"
          href={FSA_HSA_FAQ_PAGE}
          rel="noreferrer"
          target="_blank"
        >
          {chunks}
        </a>
      );
    },
  };

  if (!hsaFsa.isAvailable) {
    return null;
  }

  return (
    <Typography
      data-cy="notice_hsa_fsa_eligible"
      {...typographyProps}
      {...(className && { className })}
    >
      <RichText
        messageKey="notice_hsa_fsa_eligible_logo_inline"
        tValues={tValue}
      />
    </Typography>
  );
};

export default HsaFsaInlineLink;
